import { render } from "./InvitationsTemplate.vue?vue&type=template&id=4962b23e&scoped=true"
import script from "./InvitationsTemplate.vue?vue&type=script&lang=js"
export * from "./InvitationsTemplate.vue?vue&type=script&lang=js"

import "./InvitationsTemplate.vue?vue&type=style&index=0&id=4962b23e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/cloudstack/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4962b23e"]])

export default __exports__